module.exports = __webpack_public_path__ + "static/media/Bikkje.d5f3d5f9.mp3";